module.exports = __webpack_public_path__ + "img/gateway__vault.d65689c.svg";